/**
 * Textos de los códigos de error de `/api/kiosco`, un solo dueño para las dos
 * pantallas que hablan con ese endpoint: Fichaje (`js/kiosco.js`) y Reportes
 * del staff (`js/services/staff-reportes.service.js`, spec staff-reportes B1).
 * Mensajes distintos por código (Req: cada desenlace se distingue del resto).
 */
export const KIOSCO_ERROR_MESSAGES = {
    pin_invalido: 'PIN incorrecto.',
    // L4: el servidor sigue validando el formato (api/kiosco.js, 400) aunque
    // Confirmar ya no se habilita con menos de 4 dígitos.
    pin_formato_invalido: 'El PIN tiene que tener 4 números.',
    rate_limited: 'Demasiados intentos. Probá de nuevo en un momento.',
    no_disponible: 'El kiosco no está disponible ahora. Probá de nuevo en un momento.',
    campos_incompletos: 'Faltan datos. Probá de nuevo.',
    empleado_id_invalido: 'Empleado inválido.',
    accion_invalida: 'Acción inválida. Probá de nuevo.',
    error_interno: 'Ocurrió un error. Probá de nuevo.',
};
